import type { ExerciseAnswer } from 'api/rest/exercises/exercises.types';

export type TrueFalseAnswerGroup = {
  group: number;
  choices: ExerciseAnswer[];
};

/** Groups TRUE_FALSE choices by their `group` index (stable ascending order). */
export const groupTrueFalseAnswers = (answers: ExerciseAnswer[]): TrueFalseAnswerGroup[] => {
  const byGroup = new Map<number, ExerciseAnswer[]>();

  for (const answer of answers) {
    if (answer.group == null) {
      continue;
    }
    const existing = byGroup.get(answer.group) ?? [];
    existing.push(answer);
    byGroup.set(answer.group, existing);
  }

  return Array.from(byGroup.entries())
    .sort(([left], [right]) => left - right)
    .map(([group, choices]) => ({
      group,
      choices,
    }));
};

export const getSelectedAnswers = (answers: ExerciseAnswer[], selectedAnswerIds: number[]): ExerciseAnswer[] => {
  if (!selectedAnswerIds.length) {
    return [];
  }
  const selectedIds = new Set(selectedAnswerIds);
  return answers.filter(answer => selectedIds.has(answer.id));
};

export const isTrueFalseAnswerComplete = (answers: ExerciseAnswer[], selectedAnswerIds: number[]): boolean => {
  const groups = groupTrueFalseAnswers(answers);
  if (!groups.length) {
    return false;
  }

  const selectedByGroup = new Map<number, number>();
  for (const answerId of selectedAnswerIds) {
    const answer = answers.find(item => item.id === answerId);
    if (answer?.group == null) {
      continue;
    }
    selectedByGroup.set(answer.group, answerId);
  }

  return groups.every(({ group }) => selectedByGroup.has(group));
};
